<style lang="scss">
.cm-scrollbar-animation {
    box-sizing: border-box;
    width: 100%;
    overflow: hidden;
    position: relative;

    ::-webkit-scrollbar {
        display: none;
        width: 0px;
        /* 滚动条的宽度 */
    }

    .cm-scrollbar-body {
        width: auto;
        display: flex;
        align-items: center;
        gap: 10px;
        box-sizing: border-box;
        position: relative;

        .cm-scrollbar-item {
            display: inline-block;
            box-sizing: border-box;
        }

    }
}
</style>

<template>
    <div class="cm-scrollbar-animation" ref="cmScrollbarBox">
        <div class="cm-scrollbar-body" ref="cmScrollbarBody" @mouseenter="handleMouseEnter"
             @mouseleave="handleMouseLeave" :style="scrollbarbodyStyle">
            <div :class="itemClass" ref="cmScrollbarItem" style="getStyle" v-for="(item, index) in data" :key="index">
                <slot name="default" :row="item" :rowIndex="index" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'cm-scrollbar-animation',
    data() {
        return {
            topShow: false,
            activeName: 0,
            needTime: 0,
            init: false,
            scrollbarbodyStyle: {},
            // 滚动监听
            myInterval: null,
            // 耗时监听
            myInterval2: null,
            // 滚动方位 1 正 2 反
            nowDirection: 1,
            // 已滚动次数
            loopnum: 0,
            // 总距离
            countLen: 0,
            // 总偏移
            countOffset: 0,
            // 每次滚动总时间
            time: 0,
            // 耗时
            usetime: 0,
            // 鼠标移出恢复状态
            restore: false,
            itemClass: 'cm-scrollbar-item',


        };
    },
    props: {
        /**
         *   滚动方向 x 或者y
         */
        direction: {
            type: [String],
            required: false,
            default: 'x'
        },
        /**
         *  单个元素最大宽度 
         */
        itemWidth: {
            type: [String, Number],
            required: false,
            default: 100
        },
        /**
         *  单个元素移动时间 单位秒支持小数
         */
        speed: {
            type: [Number],
            required: false,
            default: 0.7
        },
        /**
         *  循环来回滚动 
         */
        loop: {
            type: [Boolean],
            required: false,
            default: true
        },
        /**
         *  元素列表
         */
        data: {
            type: [Array],
            required: true,
            default: '#topAnchor'
        },
        /**
        *  item元素附加类名
        */
        itemClassName: {
            type: [String],
            required: false,
            default: ''
        },
        /**
         *  附加属性
         */
        props: {
            type: [Object],
            required: false,
            default: () => {
                return {
                    title: 'title',
                    key: 'key',
                }
            }
        },

    },
    watch: {
        data: {
            handler() {
                this.$nextTick(() => {
                    this.initAnimation();
                })
            },
            deep: true
        },
        itemClassName: {
            handler(v) {
                this.itemClass = 'cm-scrollbar-item ' + v
                // console.log('this.itemClass', this.itemClass);
            },
            deep: true,
            immediate: true
        },
    },
    created() {

    },
    mounted() {
        this.$nextTick(() => {
            this.initAnimation();
        })
    },
    computed: {
        getStyle() {
            console.log('this.itemWidth', this.itemWidth);
            if ('number' === typeof this.itemWidth) {
                return {
                    width: this.itemWidth + 'px',
                    minWidth: this.itemWidth + 'px',
                }
            }

            return {
                width: this.itemWidth,
                minWidth: this.itemWidth,
            }
        }
    },
    methods: {
        /**
         * 执行动画
         */
        initAnimation() {
            clearInterval(this.myInterval);
            if (this.data.length <= 0) {
                return;
            }

            this.time = this.data.length * this.speed;

            if (this.$refs.cmScrollbarBody && this.$refs.cmScrollbarItem) {
                // 使用 offsetWidth 获取元素的宽度  
                // console.log('测试2');
                this.nowDirection = 1;

                this.myInterval = setInterval(() => {
                    this.usetime = 0;
                    this.listener();
                }, this.time * 1000);

                this.usetime = 0;
                this.myInterval2 = setInterval(() => {
                    this.usetime += 50;
                }, 50);
                this.listener();
            } else {
                // console.log('测试1');
                setTimeout(() => {
                    this.initAnimation();
                }, 10);
            }
        },
        handleMouseEnter() {
            if (this.restore == true) {
                return;
            }

            this.restore = true;
            // 挂起
            clearInterval(this.myInterval);
            clearInterval(this.myInterval2);
            // 计算当前偏移比例
            let nowNultiple = this.usetime / (this.time * 1000);
            if (this.nowDirection == 1) {
                // 回滚
                let offset = Math.floor(parseFloat((this.countOffset * (1 - nowNultiple)).toFixed(2)));
                // console.log('回滚 offset', offset);
                if (offset > 0) {
                    this.updateStyle(this.countLen, - Math.floor(parseFloat((this.countOffset * nowNultiple).toFixed(2))), this.time);
                }
            } else {
                // 正滚
                let offset = Math.floor(parseFloat((this.countOffset * nowNultiple).toFixed(2)));
                //     console.log('正滚 offset', offset);
                if (offset > 0) {
                    this.updateStyle(this.countLen, - offset, this.time);
                }
            }

            // console.log('挂起');
        },
        handleMouseLeave() {
            // console.log('恢复');
            this.restore = false;
            // 恢复
            this.updateStyle(this.countLen, 0, 0.3);
            this.nowDirection = 1;
            setTimeout(() => {
                this.initAnimation();
            }, 500);
        },
        /**
         * 监听滚动
         */
        listener() {
            this.$nextTick(() => {
                this.time = this.data.length * this.speed;

                if (this.$refs.cmScrollbarBody && this.$refs.cmScrollbarItem && this.$refs.cmScrollbarItem.length > 0) {
                    // console.log('this.nowDirection', this.nowDirection);
                    if (this.nowDirection == 2) {
                        this.loopnum++;
                        if (!this.loop) {
                            // 不重复滚动
                            clearInterval(this.myInterval);
                        }

                        this.updateStyle('auto', 0, this.time);
                    }
                    else {
                        if (this.direction == 'x') {
                            let width = this.countLen = (this.data.length * this.$refs.cmScrollbarItem[0].offsetWidth) + (this.data.length - 1) * 10;
                            let width2 = this.$refs.cmScrollbarBox.offsetWidth;
                            // console.log([this.$refs.cmScrollbarBody], [this.$refs.cmScrollbarBox]);
                            // console.log('width', width, width2, this.$refs.cmScrollbarItem[0].offsetWidth);
                            this.countOffset = width > width2 ? (width - width2) : 0
                            this.updateStyle(width, -this.countOffset, this.time);
                        } else {
                            let height = this.countLen = (this.data.length * this.$refs.cmScrollbarItem[0].offsetHeight) + (this.data.length - 1) * 10;
                            let height2 = this.$refs.cmScrollbarBox.offsetHeight;
                            this.countOffset = height > height2 ? -(height - height2) : 0
                            this.updateStyle(height, -this.countOffset, this.time);
                        }
                    }

                    if (this.restore) {
                        this.restore = false;
                        return;
                    }
                    this.nowDirection = this.nowDirection == 1 ? 2 : 1;

                } else {
                    setTimeout(() => {
                        this.listener();
                    }, 50);
                }
            });
        },
        /**
         * 更新样式
         */
        updateStyle(value, offset, time) {

            var speedtime = time * 1000;
            this.scrollbarbodyStyle = {
                'transform': this.direction == 'x' ? 'translateX(' + offset + 'px)' : 'translateY(' + offset + 'px)',
                'transition': 'opacity ' + speedtime + 'ms linear 0ms, -webkit-transform ' + speedtime + 'ms linear 0ms, transform ' + speedtime + 'ms linear 0ms',
                'transform-origin': '50 % 50 % 0px',
                'opacity': 276.462,
            }

            if (value != 'auto') {
                if (this.direction == 'x') {
                    this.scrollbarbodyStyle.width = value + 'px'
                } else {
                    this.scrollbarbodyStyle.height = value + 'px'
                }
            }

            // console.log('offset', offset);
            // console.log('this.scrollbarbodyStyle', this.scrollbarbodyStyle);
        }

    }
}
</script>


// WEBPACK FOOTER //
// src/components/CmScrollbarAnimation/index.vue